import React from "react";

// Minimal proof-of-path custom module. Demonstrates the two things a real
// custom module does: read its manifest config, and (optionally) fetch data
// from an arbitrary external API the generic components know nothing about.
//
// Manifest example (widget on Acquisition):
//   { "id": "demo", "component": "custom:example-panel",
//     "placement": { "type": "widget", "page": "acquisition" },
//     "title": "Example Panel",
//     "config": { "message": "Hello from the registry", "url": null } }
//
// Or as a standalone page with a menu entry:
//   { "id": "demo", "component": "custom:example-panel",
//     "placement": { "type": "page", "menu": { "label": "Example", "icon": "extension" } },
//     "title": "Example Panel", "config": { ... } }
export default class ExamplePanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetched: null,
      error: false
    };
  }
  componentDidMount() {
    const config = this.props.config || {};
    if (!config.url) return;
    fetch(config.url).then(r => r.json()).then(d => this.setState({
      fetched: d
    })).catch(() => this.setState({
      error: true
    }));
  }
  render() {
    const config = this.props.config || {};
    const {
      fetched,
      error
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: "custom-module-example"
    }, /*#__PURE__*/React.createElement("p", null, config.message || "This custom module is wired through the tenant registry."), config.url && /*#__PURE__*/React.createElement("pre", {
      className: "module-json"
    }, error ? "External fetch failed." : fetched ? JSON.stringify(fetched, null, 1).slice(0, 800) : "Fetching…"));
  }
}